import {
	pauseAllMedia,
	pauseYouTubeVideo,
	pauseVimeoVideo,
	pauseVideo,
} from "../utils/media";
import { loadFeatures } from "../utils/loadFeatures";

const loadModelViewerUI = loadFeatures([
	{ name: "model-viewer-ui", version: "1.0" },
]);

export default (type) => ({
	// STATE
	isLoaded: false,
	type,

	// METHODS
	load() {
		// Pause playing media.
		pauseAllMedia();

		// If the media type is `model`, load the Model Viewer UI script.
		if (type === "model") {
			loadModelViewerUI()
				.then(() => {
					new Shopify.ModelViewerUI(this.$refs.media, {
						controls: ["zoom-in", "zoom-out", "fullscreen"],
						iconUrl: window.themeAssets.modelViewerUiIconUrl,
					});
				})
				.catch((error) => {
					console.error(error);
				});
		}

		// Load the current media.
		this.isLoaded = true;
	},

	pause() {
		switch (this.type) {
			case "video":
				pauseVideo(this.$refs.media);
				break;
			case "vimeo":
				pauseVimeoVideo(this.$refs.media);
				break;
			case "youtube":
				pauseYouTubeVideo(this.$refs.media);
				break;
		}
	},
});
